import { convertSortParams } from "@/component/Report/share/params"
import { ReportParams } from "@/component/common/report/report"
import { axiosHttp } from "@/utils/http"
import dayjs from "dayjs"

const getReformModalTask = ()=>{

}
export interface GetImportExportTaskResponse {
  "taskId": number // 328618,
  "platformId": number // 1,
  "sourceType": number // 2,
  "companyId": number // 311,
  "userId": number // 1081,
  "templateId": number // 30011,
  "name": string // "-",
  "dataSourceId": number // 3017,
  "dataSourceParams": string // "{\"page\":\"1\",\"pageSize\":\"10\",\"start_time\":\"2024-02-11 00:00\",\"expect\":\"1\",\"id\":\"3874400\",\"limit\":number // 10,\"__forceSessionData\":{\"staff_id\":number // 479,\"accounts_id\":number // 1081,\"company_id\":number // 311,\"session_id\":\"sdc7bd52n1pr28bpj0u3stnt99\"},\"company_id\":number // 311,\"accounts_id\":number // 1081,\"client_id\":number // 0}",
  "status": number // 3,
  "statusText": string // "执行中",
  "expect": number // 1,
  "success": number // 0,
  "fail": number // 0,
  "files": string[],
  "errMsg": string // "",
  "createdAt": string // "2024-03-12 11:38:11",
  "created_at": string // "2024-03-12 11:38:11",
  "templateSchema": string // "",
  "progress": string // "0\/100",
  "is_can_cancel": boolean // true,
  "is_can_delete": boolean // true,
  "is_done": boolean // false,
  "type": string // "v2",
  "is_hide_create_at": boolean // false
}

export const serviceGetImportExportTask = async  (taskId:string) => {
  return await axiosHttp.get<'',AxiosHttpPromise<GetImportExportTaskResponse> >(`/RestfulApi/import-export-task/${taskId}`)
    // .then(res => {
    //   if (res.code === 200) {
    //     const time = dayjs().format('YYYY-MM-DD HH:mm:ss')
    //     dispatch(getReformModalTask(res.data, time))
    //     // 轮询
    //     const { exportModalData } = getState().taskQueue
    //     const { visibleReform, reformData } = exportModalData
    //     // 成功或者失败了之后就不再轮询了
    //     if (visibleReform && reformData.status !== 4 && reformData.status !== 5) {
    //       setTimeout(() => {
    //         getReformTaskAsync(id)
    //       }, 5000)
    //     }
    //   }else{
    //     const time = dayjs().format('YYYY-MM-DD HH:mm:ss')
    //     dispatch(getReformModalTask(false,time))
    //   }
    // })
    // .catch(err => Modal.error({ content: err.message }))
}

interface serviceCreateImportExportTask{
  taskId:string
}

export interface CreateImportExportTaskParams {
  params: {
    expect?: number|string
    count?: number,
    source?: string
    report?: string
    export_page?: number
    collaborator_company_id?: number //运营公司id
    transformer_fields?:  string //需要转换的字段
  } & ReportParams,
  expect: string,//总数
  templateCode:string,
  templateFields?: string // {code:string,valueType:number}[] //报表服务需要的导出字段  
}


// export const serviceCreateImportExportTask = async (data:CreateImportExportTaskParams):AxiosHttpPromise<serviceCreateImportExportTask> => {
export const serviceCreateImportExportTask = async (data:CreateImportExportTaskParams) => {
  const {params,expect,templateCode,templateFields}  = data
  if (!templateCode) throw new Error('新建导出任务必须传一个模板id')
  let newParams = convertSortParams(params)
  return  axiosHttp.post<'',AxiosHttpPromise<serviceCreateImportExportTask>>('/RestfulApi/import-export-task', {
    templateCode,
    expect: expect,   //总数
    params: newParams,
    templateFields,
  }, )
}